module.exports = __webpack_public_path__ + "img/desabilitar.3287811b.svg";